var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenField({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9.5c0 .492.383.875.875.875A.881.881 0 0 0 7 9.5a.9.9 0 0 0-.875-.875.881.881 0 0 0-.875.875zm9.16.219V13a.45.45 0 0 1-.437.438H1.75A.432.432 0 0 1 1.312 13V6a.45.45 0 0 1 .438-.438h6.07L9.133 4.25h-7.41C.766 4.25 0 5.043 0 6v7c0 .984.766 1.75 1.723 1.75h12.222c.957 0 1.723-.766 1.723-1.723V7.395l-1.23 1.285-.028 1.039zM2.625 9.5c0 .492.383.875.875.875a.881.881 0 0 0 .875-.875.9.9 0 0 0-.875-.875.881.881 0 0 0-.875.875zM17.5 3.074c0-.465-.191-.875-.52-1.203l-.601-.601C16.05.94 15.64.75 15.176.75c-.438 0-.875.191-1.203.52l-5.36 5.359a1.304 1.304 0 0 0-.328.601l-.41 2.051c0 .082-.027.137-.027.192 0 .492.41.902.93.902h.19l2.052-.41c.218-.055.437-.164.601-.328l5.36-5.36c.382-.382.519-.847.519-1.203zm-1.45.274L10.72 8.68l-1.422.273.273-1.422L14.902 2.2c.082-.082.164-.136.274-.136.11 0 .191.054.273.136l.602.602c.082.082.137.164.137.273 0 .11-.055.192-.137.274z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenField);
export default __webpack_public_path__ + "static/media/pen-field.84120da30ac652eac330c1cc5a263534.svg";
export { ForwardRef as ReactComponent };